import m from 'mithril';
import Component_Player from './component_player';
import i18n from "../../shared/i18n/i18n";

let reloadCallback;

export function launchInteractive(unit, course, isReview) {
    m.mount(document.getElementById('player-mount'), {
        view: function () {
            return m(Component_Player, {
                courseId: course.id,
                enrolmentId: course.enrolment.id,
                unit: unit,
                isReview: isReview,
                callback: closeInteractive
            });
        }
    });
}

export function closeInteractive(u) {
    m.mount(document.getElementById('player-mount'), null);
    if (reloadCallback)
        reloadCallback();
}

// True when launching this SCORM unit would be a review (relaunch of an
// already-completed unit) rather than a fresh attempt/retry. Used to show the
// "Review" button and the review notice on the enrolment page.
export function isScormReview(unit) {
    if (!unit?.enrolment?.allowAccess || !unit.allowRelaunchIfCompleted) return false;
    const { isCompleted, isPassed } = unit.enrolment;
    return isCompleted && (isPassed || !unit.allowRetryIfFailed);
}

function reviewButton(unit, course) {
    return m('button', { onclick: () => launchInteractive(unit, course, true) }, i18n.t('review'));
}

const Component_Unit_Actions_Scorm = {
    oninit: function (vnode) {
        let unit = vnode.attrs.unit;
        let course = vnode.attrs.course;
        let unitNumber = vnode.attrs.unitNumber;
        reloadCallback = vnode.attrs.reloadCallback;
        if (unit && course && unitNumber && unit.id === unitNumber) {
            if (!unit?.enrolment?.allowAccess) return '';
            const { isCompleted, isPassed } = unit.enrolment;
            const shouldLaunch = !isCompleted ||
                (isPassed && unit.allowRelaunchIfCompleted) ||
                (!isPassed && unit.allowRetryIfFailed);
            // Review = relaunching an already-completed unit without a fresh attempt/retry
            const isReview = isCompleted && (isPassed || !unit.allowRetryIfFailed);
            return shouldLaunch ? launchInteractive(unit, course, isReview) : '';
        }
    },
    view: function (vnode) {
        let unit = vnode.attrs.unit;
        let course = vnode.attrs.course;
        reloadCallback = vnode.attrs.reloadCallback;

        if (!unit?.enrolment?.allowAccess) return '';

        const { isCompleted, isPassed } = unit.enrolment;

        if (!isCompleted) {
            return m('button', { onclick: () => launchInteractive(unit, course, false), class: 'btn-cta' }, i18n.t('launch'));
        }

        if (isPassed) {
            if (!unit.allowRelaunchIfCompleted) return '';
            return reviewButton(unit, course);
        }

        // Failed
        if (!unit.allowRetryIfFailed) {
            if (!unit.allowRelaunchIfCompleted)  return '';
            return reviewButton(unit, course);
        }
        return m('button', { onclick: () => launchInteractive(unit, course, false), class: '' }, i18n.t('launch'));
    }
};
export default Component_Unit_Actions_Scorm;
